import React from "react";
import { Link } from "react-router-dom";
import * as MS from "../services/MenuService";
import * as Const from "../_Const";

function Breadcrumb(params) {
  const { title, section } = params;
  let sectionTitle = section;
  if (!section) {
    sectionTitle = title;
  }
  return (
    <section id="breadcrumbs" className="breadcrumbs">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
          <h2>{title}</h2>
          <ol>
            <li>
              <Link to={() => MS.getLinkFromMenuId(Const.ID_HOME)}>Domů</Link>
            </li>
            <li>{sectionTitle}</li>
          </ol>
        </div>
      </div>
    </section>
  );
}

export default Breadcrumb;
